import React, { useId } from 'react'
import { Defs, LinearGradient, Path, Stop, Svg } from 'react-native-svg'
import { TintingIntensity } from '@order/steps/types'

import { getGradientBreakpoint } from '@order/steps/attributes/utils'
import { intensityOpacity } from '@order/steps/attributes/Intensity/styles'

import { linearGradientProps, pathFrameProps, pathLensesProps } from './vectors'
import { ColorConfig, opacityToDecimal } from '@ca/common/types'
import { Intensity } from '@ca/common'

interface Props {
  colorConfig: ColorConfig
  intensity: TintingIntensity
  scale?: number
}

const gradientStart = 0.05
const gradientEnd = 0.8

const defaultBackColors = [
  {
    color: '#ffffff',
    opacity: 100,
  },
]

export default function AttributeTinting({
  colorConfig,
  intensity,
  scale = 1,
  ...props
}: Props) {
  const front = colorConfig.front
  const back =
    colorConfig.back && colorConfig.back.length > 0
      ? colorConfig.back
      : defaultBackColors
  const opacities = Intensity.utils.getIntensityOpacity(intensity)

  const id = useId()

  return (
    <Svg
      width={200 * scale}
      height={64 * scale}
      viewBox="0 0 200 64"
      fill="none"
      {...props}
    >
      <Path {...pathLensesProps} fill={`url(#tinting-${id}-back)`} />
      <Path {...pathLensesProps} fill={`url(#tinting-${id}-front)`} />
      <Path {...pathFrameProps} fill="#010101" />
      <Defs>
        <LinearGradient id={`tinting-${id}-back`} {...linearGradientProps}>
          {back.map((color, index) => (
            <Stop
              key={index}
              offset={getGradientBreakpoint(
                index,
                back.length,
                gradientStart,
                gradientEnd
              )}
              stopColor={color.color}
              stopOpacity={
                opacityToDecimal(color.opacity) *
                opacities[index % opacities.length]
              }
            />
          ))}
        </LinearGradient>
        <LinearGradient id={`tinting-${id}-front`} {...linearGradientProps}>
          {front.map((color, index) => (
            <Stop
              key={index}
              offset={getGradientBreakpoint(
                index,
                front.length,
                gradientStart,
                gradientEnd
              )}
              stopColor={color.color}
              stopOpacity={
                opacityToDecimal(color.opacity) *
                opacities[index % opacities.length]
              }
            />
          ))}
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
